import { getTenant } from '../../../theme/tokens'
export const MALAYSIAN_STATES = [
  'Kuala Lumpur',
  'Selangor',
  'Johor',
  'Penang',
  'Perak',
  'Negeri Sembilan',
  'Melaka',
  'Pahang',
  'Kedah',
  'Kelantan',
  'Terengganu',
  'Perlis',
  'Sabah',
  'Sarawak',
  'Putrajaya',
  'Labuan',
]
export const MALAYSIAN_BANKS = [
  'Bank Rakyat',
  'Bank Islam Malaysia',
  'Maybank',
  'CIMB Bank',
  'Public Bank',
  'RHB Bank',
  'Hong Leong Bank',
  'AmBank',
  'HSBC Malaysia',
  'UOB Malaysia',
]
// Backwards-compatible aliases
export const THAI_PROVINCES = MALAYSIAN_STATES
export const THAI_BANKS = MALAYSIAN_BANKS
export interface Supplier {
  id: string
  supplierType: 'company' | 'individual'
  name: string
  email: string
  phone: string
  useAsBillingEmail: boolean
  addressLine1: string
  addressLine2: string
  city: string
  province: string
  country: string
  postcode: string
  internalReference: string
  taxId: string
  companyNameTh: string
  companyNameEn: string
  branch: string
  vatRegistered: boolean
  contactPerson: string
  idType: 'citizen_id' | 'passport' | ''
  idNumber: string
  fullNameTh: string
  fullNameEn: string
  individualTaxId: string
  payInMethod: 'acquiring' | 'card'
  cardholderName: string
  cardNumber: string
  expiryDate: string
  payoutMethod: 'bank_account' | 'promptpay'
  bankName: string
  accountNumber: string
  accountName: string
  promptPayType: 'phone' | 'citizen_id' | 'tax_id' | ''
  promptPayId: string
  promptPayName: string
  amountOwed: string
  source: string
  dateCreated: string
  isArchived: boolean
}
export const mockSuppliers: Supplier[] = [
  {
    id: '1',
    supplierType: 'company',
    name: 'Test Company Sdn Bhd',
    email: 'ahmad+supplier@bankrakyat.com.my',
    phone: '+60 3 2001234',
    useAsBillingEmail: true,
    addressLine1: 'No. 12, Jalan Ampang',
    addressLine2: 'Bangsar',
    city: 'Kuala Lumpur',
    province: 'Kuala Lumpur',
    country: 'Malaysia',
    postcode: '50450',
    internalReference: 'SUP-001',
    taxId: '1023456-3',
    companyNameTh: 'Test Company Sdn Bhd',
    companyNameEn: 'Test Company Sdn Bhd',
    branch: '00000',
    vatRegistered: true,
    contactPerson: 'Ahmad Faisal',
    idType: '',
    idNumber: '',
    fullNameTh: '',
    fullNameEn: '',
    individualTaxId: '',
    payInMethod: 'acquiring',
    cardholderName: '',
    cardNumber: '',
    expiryDate: '',
    payoutMethod: 'bank_account',
    bankName: 'Bank Rakyat',
    accountNumber: '7730000123456',
    accountName: 'Test Company Sdn Bhd',
    promptPayType: '',
    promptPayId: '',
    promptPayName: '',
    amountOwed: `${getTenant().currency.code} 9,393.00`,
    source: 'Pomelo',
    dateCreated: '13/03/2026, 12:26',
    isArchived: false,
  },
  {
    id: '2',
    supplierType: 'company',
    name: 'Melati Beverages Sdn Bhd',
    email: 'rashid@melatibev.my',
    phone: '+60 3 2055901',
    useAsBillingEmail: true,
    addressLine1: 'No. 24, Jalan Bukit Bintang',
    addressLine2: 'Petaling Jaya',
    city: 'Kuala Lumpur',
    province: 'Kuala Lumpur',
    country: 'Malaysia',
    postcode: '55100',
    internalReference: 'TEA-002',
    taxId: '1011223-7',
    companyNameTh: 'Melati Beverages Sdn Bhd',
    companyNameEn: 'Melati Beverages Sdn Bhd',
    branch: '00000',
    vatRegistered: true,
    contactPerson: 'Lim Wei Sheng',
    idType: '',
    idNumber: '',
    fullNameTh: '',
    fullNameEn: '',
    individualTaxId: '',
    payInMethod: 'acquiring',
    cardholderName: '',
    cardNumber: '',
    expiryDate: '',
    payoutMethod: 'bank_account',
    bankName: 'Bank Islam Malaysia',
    accountNumber: '90100100012345',
    accountName: 'Melati Beverages Sdn Bhd',
    promptPayType: '',
    promptPayId: '',
    promptPayName: '',
    amountOwed: `${getTenant().currency.code} 0.00`,
    source: 'Manual entry',
    dateCreated: '10/01/2026, 09:15',
    isArchived: false,
  },
  {
    id: '3',
    supplierType: 'company',
    name: 'Selatan Packaging Solutions Sdn Bhd',
    email: 'rajesh@selatanpack.my',
    phone: '+60 3 2778899',
    useAsBillingEmail: false,
    addressLine1: 'Lot 10584, Jalan Tunku Abdul Rahman',
    addressLine2: 'Phase 1',
    city: 'Subang Jaya',
    province: 'Selangor',
    country: 'Malaysia',
    postcode: '47500',
    internalReference: 'PKG-003',
    taxId: '1019876-2',
    companyNameTh: 'Selatan Packaging Solutions Sdn Bhd',
    companyNameEn: 'Selatan Packaging Solutions Sdn Bhd',
    branch: '00000',
    vatRegistered: true,
    contactPerson: 'Rajesh Kumar',
    idType: '',
    idNumber: '',
    fullNameTh: '',
    fullNameEn: '',
    individualTaxId: '',
    payInMethod: 'acquiring',
    cardholderName: '',
    cardNumber: '',
    expiryDate: '',
    payoutMethod: 'bank_account',
    bankName: 'Maybank',
    accountNumber: '34561234567',
    accountName: 'Selatan Packaging Solutions Sdn Bhd',
    promptPayType: '',
    promptPayId: '',
    promptPayName: '',
    amountOwed: `${getTenant().currency.code} 45,000.00`,
    source: 'Pomelo',
    dateCreated: '05/02/2026, 14:30',
    isArchived: false,
  },
  {
    id: '4',
    supplierType: 'individual',
    name: 'Mohd Wahid',
    email: 'm.wahid@gmail.com',
    phone: '+60 1 2712345',
    useAsBillingEmail: true,
    addressLine1: 'No. 8, Jalan Sultan',
    addressLine2: 'Bangsar',
    city: 'Kuala Lumpur',
    province: 'Kuala Lumpur',
    country: 'Malaysia',
    postcode: '50000',
    internalReference: '',
    taxId: '',
    companyNameTh: '',
    companyNameEn: '',
    branch: '',
    vatRegistered: false,
    contactPerson: '',
    idType: 'citizen_id',
    idNumber: 'A123456',
    fullNameTh: 'Mohd Wahid',
    fullNameEn: 'Mohd Wahid',
    individualTaxId: '',
    payInMethod: 'acquiring',
    cardholderName: '',
    cardNumber: '',
    expiryDate: '',
    payoutMethod: 'promptpay',
    bankName: '',
    accountNumber: '',
    accountName: '',
    promptPayType: 'phone',
    promptPayId: '+60 1 2712345',
    promptPayName: 'Mohd Wahid',
    amountOwed: `${getTenant().currency.code} 0.00`,
    source: 'Manual entry',
    dateCreated: '12/04/2026, 11:20',
    isArchived: true,
  },
  {
    id: '5',
    supplierType: 'company',
    name: 'KL Fresh Produce Sdn Bhd',
    email: 'procurement@klfresh.my',
    phone: '+60 3 2234567',
    useAsBillingEmail: true,
    addressLine1: 'No. 15, Jalan Ampang',
    addressLine2: 'Petaling Jaya',
    city: 'Kuala Lumpur',
    province: 'Kuala Lumpur',
    country: 'Malaysia',
    postcode: '50450',
    internalReference: 'FRESH-005',
    taxId: '1004567-8',
    companyNameTh: 'KL Fresh Produce Sdn Bhd',
    companyNameEn: 'KL Fresh Produce Sdn Bhd',
    branch: '00000',
    vatRegistered: true,
    contactPerson: 'Nurul Aishah',
    idType: '',
    idNumber: '',
    fullNameTh: '',
    fullNameEn: '',
    individualTaxId: '',
    payInMethod: 'acquiring',
    cardholderName: '',
    cardNumber: '',
    expiryDate: '',
    payoutMethod: 'bank_account',
    bankName: 'Bank Rakyat',
    accountNumber: '7730000456789',
    accountName: 'KL Fresh Produce Sdn Bhd',
    promptPayType: '',
    promptPayId: '',
    promptPayName: '',
    amountOwed: `${getTenant().currency.code} 128,500.00`,
    source: 'Pomelo',
    dateCreated: '20/05/2026, 08:45',
    isArchived: false,
  },
  {
    id: '6',
    supplierType: 'company',
    name: 'KL Digital Print House',
    email: 'sales@kldigitalprint.my',
    phone: '+60 3 2267890',
    useAsBillingEmail: true,
    addressLine1: 'No. 18, Jalan Sultan',
    addressLine2: 'Petaling Jaya',
    city: 'Kuala Lumpur',
    province: 'Kuala Lumpur',
    country: 'Malaysia',
    postcode: '50000',
    internalReference: 'PRT-006',
    taxId: '1003456-4',
    companyNameTh: 'KL Digital Print House Sdn Bhd',
    companyNameEn: 'KL Digital Print House Sdn Bhd',
    branch: '00001',
    vatRegistered: true,
    contactPerson: 'Tan Chee Keong',
    idType: '',
    idNumber: '',
    fullNameTh: '',
    fullNameEn: '',
    individualTaxId: '',
    payInMethod: 'card',
    cardholderName: 'Tan Chee Keong',
    cardNumber: '4111XXXXXXXX4242',
    expiryDate: '09/27',
    payoutMethod: 'bank_account',
    bankName: 'CIMB Bank',
    accountNumber: '0019876543',
    accountName: 'KL Digital Print House Sdn Bhd',
    promptPayType: '',
    promptPayId: '',
    promptPayName: '',
    amountOwed: `${getTenant().currency.code} 22,750.00`,
    source: 'Manual entry',
    dateCreated: '03/01/2026, 16:10',
    isArchived: false,
  },
  {
    id: '7',
    supplierType: 'company',
    name: 'Southern Logistics Sdn Bhd',
    email: 'accounts@southernlog.my',
    phone: '+60 7 2888456',
    useAsBillingEmail: true,
    addressLine1: 'No. 30, Jalan Tunku Abdul Rahman',
    addressLine2: 'Taman Sentosa',
    city: 'Johor Bahru',
    province: 'Johor',
    country: 'Malaysia',
    postcode: '80150',
    internalReference: 'LOG-007',
    taxId: '1008765-1',
    companyNameTh: 'Southern Logistics Sdn Bhd',
    companyNameEn: 'Southern Logistics Sdn Bhd',
    branch: '00000',
    vatRegistered: true,
    contactPerson: 'Hisham Manaf',
    idType: '',
    idNumber: '',
    fullNameTh: '',
    fullNameEn: '',
    individualTaxId: '',
    payInMethod: 'acquiring',
    cardholderName: '',
    cardNumber: '',
    expiryDate: '',
    payoutMethod: 'bank_account',
    bankName: 'Bank Rakyat',
    accountNumber: '7730009876543',
    accountName: 'Southern Logistics Sdn Bhd',
    promptPayType: '',
    promptPayId: '',
    promptPayName: '',
    amountOwed: `${getTenant().currency.code} 67,200.00`,
    source: 'Pomelo',
    dateCreated: '15/04/2026, 10:30',
    isArchived: false,
  },
  {
    id: '8',
    supplierType: 'individual',
    name: 'Farah Shaira',
    email: 'farah.shaira@hotmail.com',
    phone: '+60 1 2823456',
    useAsBillingEmail: true,
    addressLine1: 'Lot 24, Jalan Tun Razak',
    addressLine2: '',
    city: 'Johor Bahru',
    province: 'Johor',
    country: 'Malaysia',
    postcode: '80000',
    internalReference: '',
    taxId: '',
    companyNameTh: '',
    companyNameEn: '',
    branch: '',
    vatRegistered: false,
    contactPerson: '',
    idType: 'citizen_id',
    idNumber: 'A234567',
    fullNameTh: 'Farah Shaira',
    fullNameEn: 'Farah Shaira',
    individualTaxId: '',
    payInMethod: 'acquiring',
    cardholderName: '',
    cardNumber: '',
    expiryDate: '',
    payoutMethod: 'bank_account',
    bankName: 'Bank Rakyat',
    accountNumber: '7710001234567',
    accountName: 'Farah Shaira',
    promptPayType: '',
    promptPayId: '',
    promptPayName: '',
    amountOwed: `${getTenant().currency.code} 15,000.00`,
    source: 'Manual entry',
    dateCreated: '22/02/2026, 13:45',
    isArchived: false,
  },
  {
    id: '9',
    supplierType: 'company',
    name: 'Cameron Agriculture Sdn Bhd',
    email: 'info@cameronag.my',
    phone: '+60 5 2444567',
    useAsBillingEmail: true,
    addressLine1: 'No. 5, Jalan Besar',
    addressLine2: 'Tanah Rata',
    city: 'Cameron Highlands',
    province: 'Pahang',
    country: 'Malaysia',
    postcode: '39000',
    internalReference: 'AGR-009',
    taxId: '1001122-9',
    companyNameTh: 'Cameron Agriculture Sdn Bhd',
    companyNameEn: 'Cameron Agriculture Sdn Bhd',
    branch: '00000',
    vatRegistered: false,
    contactPerson: 'Kavitha Devi',
    idType: '',
    idNumber: '',
    fullNameTh: '',
    fullNameEn: '',
    individualTaxId: '',
    payInMethod: 'acquiring',
    cardholderName: '',
    cardNumber: '',
    expiryDate: '',
    payoutMethod: 'bank_account',
    bankName: 'Bank Islam Malaysia',
    accountNumber: '90100200012345',
    accountName: 'Cameron Agriculture Sdn Bhd',
    promptPayType: '',
    promptPayId: '',
    promptPayName: '',
    amountOwed: `${getTenant().currency.code} 0.00`,
    source: 'API',
    dateCreated: '08/02/2026, 09:00',
    isArchived: false,
  },
  {
    id: '10',
    supplierType: 'company',
    name: 'Straits Seafood Export Sdn Bhd',
    email: 'export@straitsseafood.my',
    phone: '+60 4 2522234',
    useAsBillingEmail: false,
    addressLine1: 'No. 7, Jalan Ampang',
    addressLine2: 'Industrial Zone',
    city: 'Penang',
    province: 'Penang',
    country: 'Malaysia',
    postcode: '11900',
    internalReference: 'SEA-010',
    taxId: '1006543-5',
    companyNameTh: 'Straits Seafood Export Sdn Bhd',
    companyNameEn: 'Straits Seafood Export Sdn Bhd',
    branch: '00000',
    vatRegistered: true,
    contactPerson: 'Maria Fernandez',
    idType: '',
    idNumber: '',
    fullNameTh: '',
    fullNameEn: '',
    individualTaxId: '',
    payInMethod: 'acquiring',
    cardholderName: '',
    cardNumber: '',
    expiryDate: '',
    payoutMethod: 'bank_account',
    bankName: 'Bank Rakyat',
    accountNumber: '7730001119876',
    accountName: 'Straits Seafood Export Sdn Bhd',
    promptPayType: '',
    promptPayId: '',
    promptPayName: '',
    amountOwed: `${getTenant().currency.code} 234,100.00`,
    source: 'Pomelo',
    dateCreated: '01/11/2025, 11:15',
    isArchived: false,
  },
  {
    id: '11',
    supplierType: 'company',
    name: 'KL Office Supplies Sdn Bhd',
    email: 'orders@kloffice.my',
    phone: '+60 3 2222333',
    useAsBillingEmail: true,
    addressLine1: 'No. 22, Jalan Tun Razak',
    addressLine2: 'Petaling Jaya',
    city: 'Kuala Lumpur',
    province: 'Kuala Lumpur',
    country: 'Malaysia',
    postcode: '50400',
    internalReference: 'OFF-011',
    taxId: '1002233-0',
    companyNameTh: 'KL Office Supplies Sdn Bhd',
    companyNameEn: 'KL Office Supplies Sdn Bhd',
    branch: '00000',
    vatRegistered: true,
    contactPerson: 'Aisha Zahra',
    idType: '',
    idNumber: '',
    fullNameTh: '',
    fullNameEn: '',
    individualTaxId: '',
    payInMethod: 'card',
    cardholderName: 'Aisha Zahra',
    cardNumber: '5500XXXXXXXX1234',
    expiryDate: '12/28',
    payoutMethod: 'bank_account',
    bankName: 'Public Bank',
    accountNumber: '9881234567',
    accountName: 'KL Office Supplies Sdn Bhd',
    promptPayType: '',
    promptPayId: '',
    promptPayName: '',
    amountOwed: `${getTenant().currency.code} 8,450.00`,
    source: 'Manual entry',
    dateCreated: '28/01/2026, 15:20',
    isArchived: false,
  },
  {
    id: '12',
    supplierType: 'individual',
    name: 'Ali Nasir',
    email: 'ali.nasir@gmail.com',
    phone: '+60 1 2654321',
    useAsBillingEmail: true,
    addressLine1: 'No. 9, Jalan Bukit Bintang',
    addressLine2: 'Mont Kiara',
    city: 'Kuala Lumpur',
    province: 'Kuala Lumpur',
    country: 'Malaysia',
    postcode: '50480',
    internalReference: 'FRL-012',
    taxId: '',
    companyNameTh: '',
    companyNameEn: '',
    branch: '',
    vatRegistered: false,
    contactPerson: '',
    idType: 'citizen_id',
    idNumber: 'A345678',
    fullNameTh: 'Ali Nasir',
    fullNameEn: 'Ali Nasir',
    individualTaxId: '',
    payInMethod: 'acquiring',
    cardholderName: '',
    cardNumber: '',
    expiryDate: '',
    payoutMethod: 'promptpay',
    bankName: '',
    accountNumber: '',
    accountName: '',
    promptPayType: 'citizen_id',
    promptPayId: 'A345678',
    promptPayName: 'Ali Nasir',
    amountOwed: `${getTenant().currency.code} 3,200.00`,
    source: 'Manual entry',
    dateCreated: '14/02/2026, 09:30',
    isArchived: false,
  },
  {
    id: '13',
    supplierType: 'company',
    name: 'Northern Textile Mills Sdn Bhd',
    email: 'sales@northerntextile.my',
    phone: '+60 4 2520901',
    useAsBillingEmail: true,
    addressLine1: 'No. 11, Jalan Industri',
    addressLine2: '',
    city: 'Penang',
    province: 'Penang',
    country: 'Malaysia',
    postcode: '11900',
    internalReference: 'TXT-013',
    taxId: '1007788-3',
    companyNameTh: 'Northern Textile Mills Sdn Bhd',
    companyNameEn: 'Northern Textile Mills Sdn Bhd',
    branch: '00000',
    vatRegistered: true,
    contactPerson: 'Abdullah Latif',
    idType: '',
    idNumber: '',
    fullNameTh: '',
    fullNameEn: '',
    individualTaxId: '',
    payInMethod: 'acquiring',
    cardholderName: '',
    cardNumber: '',
    expiryDate: '',
    payoutMethod: 'bank_account',
    bankName: 'Bank Islam Malaysia',
    accountNumber: '90100300012345',
    accountName: 'Northern Textile Mills Sdn Bhd',
    promptPayType: '',
    promptPayId: '',
    promptPayName: '',
    amountOwed: `${getTenant().currency.code} 89,300.00`,
    source: 'Pomelo',
    dateCreated: '19/03/2026, 14:00',
    isArchived: false,
  },
  {
    id: '14',
    supplierType: 'company',
    name: 'Tropical Coconut Products Sdn Bhd',
    email: 'info@tropicalcoconut.my',
    phone: '+60 9 2655123',
    useAsBillingEmail: true,
    addressLine1: 'No. 3, Jalan Pantai',
    addressLine2: '',
    city: 'Kuantan',
    province: 'Pahang',
    country: 'Malaysia',
    postcode: '25000',
    internalReference: 'COC-014',
    taxId: '1009900-2',
    companyNameTh: 'Tropical Coconut Products Sdn Bhd',
    companyNameEn: 'Tropical Coconut Products Sdn Bhd',
    branch: '00000',
    vatRegistered: false,
    contactPerson: 'Aishah Rina',
    idType: '',
    idNumber: '',
    fullNameTh: '',
    fullNameEn: '',
    individualTaxId: '',
    payInMethod: 'acquiring',
    cardholderName: '',
    cardNumber: '',
    expiryDate: '',
    payoutMethod: 'promptpay',
    bankName: '',
    accountNumber: '',
    accountName: '',
    promptPayType: 'tax_id',
    promptPayId: '1009900-2',
    promptPayName: 'Tropical Coconut Products Sdn Bhd',
    amountOwed: `${getTenant().currency.code} 0.00`,
    source: 'API',
    dateCreated: '05/12/2025, 10:00',
    isArchived: false,
  },
  {
    id: '15',
    supplierType: 'company',
    name: 'Klang Clean Services Sdn Bhd',
    email: 'billing@klangclean.my',
    phone: '+60 3 2311122',
    useAsBillingEmail: true,
    addressLine1: 'No. 14, Jalan Sultan',
    addressLine2: 'Mont Kiara',
    city: 'Kuala Lumpur',
    province: 'Kuala Lumpur',
    country: 'Malaysia',
    postcode: '50480',
    internalReference: 'CLN-015',
    taxId: '1005566-6',
    companyNameTh: 'Klang Clean Services Sdn Bhd',
    companyNameEn: 'Klang Clean Services Sdn Bhd',
    branch: '00000',
    vatRegistered: true,
    contactPerson: 'Hassan Farouk',
    idType: '',
    idNumber: '',
    fullNameTh: '',
    fullNameEn: '',
    individualTaxId: '',
    payInMethod: 'acquiring',
    cardholderName: '',
    cardNumber: '',
    expiryDate: '',
    payoutMethod: 'bank_account',
    bankName: 'RHB Bank',
    accountNumber: '55512345670',
    accountName: 'Klang Clean Services Sdn Bhd',
    promptPayType: '',
    promptPayId: '',
    promptPayName: '',
    amountOwed: `${getTenant().currency.code} 18,900.00`,
    source: 'Manual entry',
    dateCreated: '11/05/2026, 08:30',
    isArchived: false,
  },
  {
    id: '16',
    supplierType: 'individual',
    name: 'Shen Hassan',
    email: 'shen.hassan@outlook.com',
    phone: '+60 1 2555678',
    useAsBillingEmail: true,
    addressLine1: 'No. 16, Jalan Ampang',
    addressLine2: 'Petaling Jaya',
    city: 'Kuala Lumpur',
    province: 'Kuala Lumpur',
    country: 'Malaysia',
    postcode: '50450',
    internalReference: '',
    taxId: '',
    companyNameTh: '',
    companyNameEn: '',
    branch: '',
    vatRegistered: false,
    contactPerson: '',
    idType: 'passport',
    idNumber: 'M0123456',
    fullNameTh: 'Shen Hassan',
    fullNameEn: 'Shen Hassan',
    individualTaxId: '',
    payInMethod: 'acquiring',
    cardholderName: '',
    cardNumber: '',
    expiryDate: '',
    payoutMethod: 'promptpay',
    bankName: '',
    accountNumber: '',
    accountName: '',
    promptPayType: 'phone',
    promptPayId: '+60 1 2555678',
    promptPayName: 'Shen Hassan',
    amountOwed: `${getTenant().currency.code} 0.00`,
    source: 'Manual entry',
    dateCreated: '02/03/2026, 11:00',
    isArchived: false,
  },
  {
    id: '17',
    supplierType: 'company',
    name: 'Eastern Rice Trading Sdn Bhd',
    email: 'trade@easternrice.my',
    phone: '+60 9 2722234',
    useAsBillingEmail: true,
    addressLine1: 'No. 21, Jalan Besar',
    addressLine2: '',
    city: 'Kota Bharu',
    province: 'Kelantan',
    country: 'Malaysia',
    postcode: '15000',
    internalReference: 'RICE-017',
    taxId: '1004455-7',
    companyNameTh: 'Eastern Rice Trading Sdn Bhd',
    companyNameEn: 'Eastern Rice Trading Sdn Bhd',
    branch: '00000',
    vatRegistered: true,
    contactPerson: 'Mohd Hafiz',
    idType: '',
    idNumber: '',
    fullNameTh: '',
    fullNameEn: '',
    individualTaxId: '',
    payInMethod: 'acquiring',
    cardholderName: '',
    cardNumber: '',
    expiryDate: '',
    payoutMethod: 'bank_account',
    bankName: 'Bank Islam Malaysia',
    accountNumber: '90100400012345',
    accountName: 'Eastern Rice Trading Sdn Bhd',
    promptPayType: '',
    promptPayId: '',
    promptPayName: '',
    amountOwed: `${getTenant().currency.code} 156,000.00`,
    source: 'Pomelo',
    dateCreated: '25/01/2026, 13:15',
    isArchived: false,
  },
  {
    id: '18',
    supplierType: 'company',
    name: 'Klang Valley Industries Sdn Bhd',
    email: 'procurement@klangvalleyind.my',
    phone: '+60 3 2601234',
    useAsBillingEmail: true,
    addressLine1: 'No. 18, Jalan Industri',
    addressLine2: '',
    city: 'Klang',
    province: 'Selangor',
    country: 'Malaysia',
    postcode: '41000',
    internalReference: 'RBR-018',
    taxId: '1003344-1',
    companyNameTh: 'Klang Valley Industries Sdn Bhd',
    companyNameEn: 'Klang Valley Industries Sdn Bhd',
    branch: '00000',
    vatRegistered: true,
    contactPerson: 'Ismail Said',
    idType: '',
    idNumber: '',
    fullNameTh: '',
    fullNameEn: '',
    individualTaxId: '',
    payInMethod: 'acquiring',
    cardholderName: '',
    cardNumber: '',
    expiryDate: '',
    payoutMethod: 'bank_account',
    bankName: 'Bank Rakyat',
    accountNumber: '7730008881234',
    accountName: 'Klang Valley Industries Sdn Bhd',
    promptPayType: '',
    promptPayId: '',
    promptPayName: '',
    amountOwed: `${getTenant().currency.code} 312,500.00`,
    source: 'API',
    dateCreated: '14/09/2025, 09:45',
    isArchived: false,
  },
  {
    id: '19',
    supplierType: 'company',
    name: 'Langkawi Tour Operators Sdn Bhd',
    email: 'finance@langkawitours.my',
    phone: '+60 4 2889012',
    useAsBillingEmail: false,
    addressLine1: 'No. 25, Jalan Pantai Cenang',
    addressLine2: 'Phase 2',
    city: 'Langkawi',
    province: 'Kedah',
    country: 'Malaysia',
    postcode: '07000',
    internalReference: 'TOUR-019',
    taxId: '1008877-2',
    companyNameTh: 'Langkawi Tour Operators Sdn Bhd',
    companyNameEn: 'Langkawi Tour Operators Sdn Bhd',
    branch: '00000',
    vatRegistered: false,
    contactPerson: 'Aishah Liyana',
    idType: '',
    idNumber: '',
    fullNameTh: '',
    fullNameEn: '',
    individualTaxId: '',
    payInMethod: 'card',
    cardholderName: 'Aishah Liyana',
    cardNumber: '4532XXXXXXXX8901',
    expiryDate: '03/28',
    payoutMethod: 'bank_account',
    bankName: 'HSBC Malaysia',
    accountNumber: '77712345670',
    accountName: 'Langkawi Tour Operators Sdn Bhd',
    promptPayType: '',
    promptPayId: '',
    promptPayName: '',
    amountOwed: `${getTenant().currency.code} 41,600.00`,
    source: 'Pomelo',
    dateCreated: '28/02/2026, 16:30',
    isArchived: false,
  },
  {
    id: '20',
    supplierType: 'company',
    name: 'Old Warehouse Supplies Sdn Bhd',
    email: 'info@oldwarehouse.my',
    phone: '+60 3 2344455',
    useAsBillingEmail: true,
    addressLine1: 'No. 20, Jalan Tun Razak',
    addressLine2: 'Petaling Jaya',
    city: 'Kuala Lumpur',
    province: 'Kuala Lumpur',
    country: 'Malaysia',
    postcode: '50400',
    internalReference: 'WH-020',
    taxId: '1001100-0',
    companyNameTh: 'Old Warehouse Supplies Sdn Bhd',
    companyNameEn: 'Old Warehouse Supplies Sdn Bhd',
    branch: '00000',
    vatRegistered: true,
    contactPerson: 'Mohd Niaz',
    idType: '',
    idNumber: '',
    fullNameTh: '',
    fullNameEn: '',
    individualTaxId: '',
    payInMethod: 'acquiring',
    cardholderName: '',
    cardNumber: '',
    expiryDate: '',
    payoutMethod: 'bank_account',
    bankName: 'Bank Rakyat',
    accountNumber: '7730001231234',
    accountName: 'Old Warehouse Supplies Sdn Bhd',
    promptPayType: '',
    promptPayId: '',
    promptPayName: '',
    amountOwed: `${getTenant().currency.code} 0.00`,
    source: 'Manual entry',
    dateCreated: '18/05/2024, 10:00',
    isArchived: true,
  },
  {
    id: '21',
    supplierType: 'individual',
    name: 'Aisha Yusra',
    email: 'aisha.yusra@yahoo.com',
    phone: '+60 1 2345678',
    useAsBillingEmail: true,
    addressLine1: 'No. 27, Jalan Bukit Bintang',
    addressLine2: 'Bangsar',
    city: 'Kuala Lumpur',
    province: 'Kuala Lumpur',
    country: 'Malaysia',
    postcode: '50450',
    internalReference: '',
    taxId: '',
    companyNameTh: '',
    companyNameEn: '',
    branch: '',
    vatRegistered: false,
    contactPerson: '',
    idType: 'citizen_id',
    idNumber: 'A456789',
    fullNameTh: 'Aisha Yusra',
    fullNameEn: 'Aisha Yusra',
    individualTaxId: '',
    payInMethod: 'acquiring',
    cardholderName: '',
    cardNumber: '',
    expiryDate: '',
    payoutMethod: 'bank_account',
    bankName: 'Bank Rakyat',
    accountNumber: '7710003456789',
    accountName: 'Aisha Yusra',
    promptPayType: '',
    promptPayId: '',
    promptPayName: '',
    amountOwed: `${getTenant().currency.code} 7,500.00`,
    source: 'Manual entry',
    dateCreated: '06/01/2026, 14:20',
    isArchived: false,
  },
  {
    id: '22',
    supplierType: 'company',
    name: 'Defunct Trading Sdn Bhd',
    email: 'old@defuncttrading.my',
    phone: '+60 3 2311100',
    useAsBillingEmail: true,
    addressLine1: 'No. 22, Jalan Sultan',
    addressLine2: 'Bangsar',
    city: 'Kuala Lumpur',
    province: 'Kuala Lumpur',
    country: 'Malaysia',
    postcode: '50000',
    internalReference: 'DEF-022',
    taxId: '1009999-3',
    companyNameTh: 'Defunct Trading Sdn Bhd',
    companyNameEn: 'Defunct Trading Sdn Bhd',
    branch: '00000',
    vatRegistered: false,
    contactPerson: 'N/A',
    idType: '',
    idNumber: '',
    fullNameTh: '',
    fullNameEn: '',
    individualTaxId: '',
    payInMethod: 'acquiring',
    cardholderName: '',
    cardNumber: '',
    expiryDate: '',
    payoutMethod: 'bank_account',
    bankName: 'UOB Malaysia',
    accountNumber: '33312345670',
    accountName: 'Defunct Trading Sdn Bhd',
    promptPayType: '',
    promptPayId: '',
    promptPayName: '',
    amountOwed: `${getTenant().currency.code} 0.00`,
    source: 'Manual entry',
    dateCreated: '01/03/2024, 08:00',
    isArchived: true,
  },
]
export interface InvitedSupplier {
  id: string
  name: string
  supplierType: 'company' | 'individual'
  inviteLink: string
  dateInvited: string
  daysAgo: number
}
export const mockInvitedSuppliers: InvitedSupplier[] = [
  {
    id: 'inv-1',
    name: 'KL Fresh Market Sdn Bhd',
    supplierType: 'company',
    inviteLink: '/supplier-onboarding/a1b2c3d4e5',
    dateInvited: '14/02/2026, 10:30',
    daysAgo: 30,
  },
  {
    id: 'inv-2',
    name: 'Nazran Adam',
    supplierType: 'individual',
    inviteLink: '/supplier-onboarding/f6g7h8i9j0',
    dateInvited: '05/03/2026, 14:15',
    daysAgo: 11,
  },
  {
    id: 'inv-3',
    name: 'KL Organic Produce Sdn Bhd',
    supplierType: 'company',
    inviteLink: '/supplier-onboarding/k1l2m3n4o5',
    dateInvited: '12/03/2026, 09:00',
    daysAgo: 4,
  },
]
